import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/ui/select';
import type { PublishingRosterArtist } from 'types/publishing';
import { ui } from '../ui';

interface Props {
  artists: PublishingRosterArtist[];
  value: string | null;
  onChange: (spotifyArtistId: string) => void;
  admin: boolean;
}

/** Design `ArtistPicker`; shown only for admins and users with several Spotify-id profiles (FR-02a). */
export function ArtistPicker({ artists, value, onChange, admin }: Props) {
  const { t } = useTranslation('publishing');
  return (
    <div className="mb-3 flex flex-wrap items-center gap-2">
      <span className={ui.muted}>{admin ? t('view_as_admin') : t('view_as')}</span>
      <Select value={value || undefined} onValueChange={onChange}>
        <SelectTrigger
          className={`h-9 max-w-[280px] w-auto min-w-[160px] gap-2 border-0 bg-gray-100 px-2 box-border ${ui.body}`}
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent position="popper" className="max-h-[360px]">
          {artists.map((a) => (
            <SelectItem key={a.spotifyArtistId} value={a.spotifyArtistId} className={ui.body}>
              {a.artistName}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <span className={ui.muted}>{t('artists_count', { count: artists.length })}</span>
    </div>
  );
}
